import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_91: DocMigration = {
  maxSchemaVersion: "0.0.91",
  description: "Migrate DoorExt_Double36 to DoorExt_Double30",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const settings = json.settings[settingId];
        if (settings.type === "EXTERIOR_PROP_SETTINGS") {
          for (const settingKey of Object.keys(settings)) {
            if (settings[settingKey].startsWith("DoorExt_Double36")) {
              settings[settingKey] = settings[settingKey].replace("DoorExt_Double36", "DoorExt_Double30");
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_91;
